import React from "react";
import styled from "styled-components";
import theme from "../utils/theme";
import MainBanner from "./common/MainBanner";
import PhoneHand from "../assets/homebanner/phone-hand.png";
import License from "../assets/homebanner/license2_new.png";

const cdn_url = process.env.REACT_APP_CDN_API_SERVER_URL;
const MBackgroundLine = `${cdn_url}/assets/version-2/main/m-banner-background-line.svg`;

/**
 * @brief v.2.0 메인페이지 배너
 */
export default function HomeBanner({ scrollToForm }) {
  return (
    <MainBanner img={MBackgroundLine}>
      <BannerDiv>
        <LicenseImg src={License} alt="온라인대출모집법인 라이센스" />
        <BannerText>
          <BiggerText>
            금융감독원 등록<br />
            <span style={{ paddingLeft: '60px' }}>대출비교 플랫폼</span><br /><br />
            타던차 그대로 대출받는<br />
            오토론 비교 서비스
          </BiggerText>
          <BigText>
            신용대출보다 더 많은 한도가 필요할 때<br />
            신용대출이 거절되었을 때<br />
            최대한도 1억까지<br />
            최장 120개월 넉넉한 상환기간
          </BigText>
          <BannerButton onClick={scrollToForm}>
            더 알아볼래요
          </BannerButton>
        </BannerText>
        <BannerImage src={PhoneHand} alt="bank-img" />
      </BannerDiv>
    </MainBanner>
  );
}

const BiggerText = styled.span`
  color: ${theme.navyColor};
  font-weight: 800;
  font-size: 32px;
  line-height: 1.15;
  // margin-top: 10px;
  margin-bottom: 12px;
`;

const BigText = styled.span`
  color: ${theme.navyColor};
  font-size: 18px;
  line-height: 1.15;
  margin-top: 30px;
  margin-bottom: 20px;
  font-weight: 400;
`;

const BannerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
`;

const BannerText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0;
  h1 {
    color: ${theme.navyColor};
    font-weight: 700;
    font-size: 28px;
    line-height: 1.15;
    margin-bottom: 12px;
  }
  h5 {
    color: ${theme.gray60Color};
    font-weight: 400;
    font-size: 13px;
    margin-bottom: 16px;
  }
`;

const BannerButton = styled.button`
  color: white;
  font-weight: 500;
  font-size: 14px;
  width: 150px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    92deg,
    ${theme.orangeGradientColor} 10.5%,
    ${theme.yellowGradientColor} 114%
  );
  box-shadow: 0px 18px 46px rgba(249, 159, 29, 0.16);
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;

const BannerImage = styled.img`
  // margin-top: 30px;
  width: 300px;
  height: auto;
  display: flex;
  // margin-left: auto;
  align-self: center;
`;

const LicenseImg = styled.img`
  margin: 0 0 30px 0;
  width: 300px;
  height: auto;
  display: flex;
  align-self: center;
`; 